import { bento } from './bento';
import { DEFAULT_DESIGN, DESIGN_IDS, type DesignId } from './config';
import { nebula } from './nebula';
import { storybook } from './storybook';
import { studio } from './studio';
import type { DesignDefinition } from './types';

/** Runtime registry: name, preview colors and motion of every design. */
export const designs: Record<DesignId, DesignDefinition> = { storybook, nebula, bento, studio };

/** In the order of DESIGN_IDS, for menus. */
export const designList: DesignDefinition[] = DESIGN_IDS.map((id) => designs[id]);

export const defaultDesign = designs[DEFAULT_DESIGN];
